import { FC } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/ar encyclopedy.png";

interface FilterHeaderProps {
  onClose: () => void;
}

const FilterHeader: FC<FilterHeaderProps> = ({ onClose }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/", { replace: true });
  };

  return (
    <header className="bg-white dark:bg-darkSecondaryBackground py-4 px-4 shadow w-full">
      <div className="flex items-center w-full">
        <div className="flex items-center">
          <img
            src={logo}
            alt="Logo"
            className="h-8 w-auto cursor-pointer"
            onClick={handleLogoClick}
          />
        </div>
        <div className="ml-auto flex items-center">
          <button onClick={onClose} className="dark:text-white">
            <CloseIcon />
          </button>
        </div>
      </div>
    </header>
  );
};

export default FilterHeader;
